
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/free-course/back-end-website",
      function () {
        return require("private-next-pages/program/free-course/back-end-website.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/free-course/back-end-website"])
      });
    }
  